<template>
  <div>
    <div v-if="items && Array.isArray(items)" class="landing-articles">
      <h2 class="h2 text-center mb-4 mb-sm-6 mb-lg-11">
        О нас пишут
      </h2>
      <VRow>
        <VCol v-for="(item,index) in items" :key="index" sm="6" cols="12" class="landing-articles__item-wrap">
          <VCard class="landing-articles__item">
            <div class="landing-articles__logo-wrap d-flex align-center mb-5 mb-md-7">
              <img
                :src="require(`../../assets/img/landing/articles/${item.logo}`)"
                alt=""
                class="landing-info__logo"
              >
            </div>
            <div class="landing-articles__text mb-11">
              {{ item.text }}
            </div>
            <a class="landing-articles__link" target="_blank" :href="item.link">{{ item.name }}</a>
          </VCard>
        </VCol>
      </VRow>
    </div>
  </div>
</template>

<script>
import { APP_NAME } from '@/helpers/constants';

export default {
  name: 'LandingArticles',
  data() {
    return {
      APP_NAME,
    };
  },
  computed: {
    items() {
      const items = this.$t('items');
      if (!items || !Array.isArray(items)) return items;
      return items.map(item => ({
        ...item,
        text: item.text
          ? item.text.replace(/Huntica\.works/g, this.APP_NAME).replace(/Huntica\b/g, this.APP_NAME.replace(/\.\w+$/, ''))
          : item.text,
      }));
    },
  },
};
</script>

<style scoped lang="scss">
  .landing-articles {
    margin-bottom: 152px;
    &__item {
      height: 100%;
      background: #FFFFFF;
      border-radius: 10px;
      padding: 40px 60px 74px 60px;
      &.v-card {
        box-shadow: 0px 10px 40px rgba(13, 131, 208, 0.13);
      }
    }
    &__logo-wrap {
      height: 96px;
    }
    &__logo {
      max-height: 100%;
    }
    &__text {
      font-size: 20px;
      font-weight: 300;
      line-height: 1.25;
      color: #333333;
    }
    &__link {
      font-size: 24px;
      font-weight: 500;
      color: #0A82D9;
      padding-right: 47px;
      background: url("../../assets/img/landing/articles/articles-link.svg") no-repeat right center;
      text-decoration: none;
      position: absolute;
      bottom: 38px;
    }
  }

  @media #{map-get($display-breakpoints, 'md-and-down')} {
    .landing-articles {
      margin-bottom: 120px;
      &__item {
        padding: 40px 31px 46px 31px;
      }
      &__text {
        font-size: 20px;
        font-weight: 300;
        line-height: 1.3;
        color: #333333;
      }
      &__link {
        font-size: 20px;
        font-weight: 400;
        padding-right: 40px;
      }
    }
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .landing-articles {
      margin-bottom: 90px;
      &__logo-wrap {
        height: auto;
      }
    }
  }

</style>

<i18n locale="en" lang="yaml">

</i18n>

<i18n locale="ru" lang="yaml">
  items:
  - logo: articles1.svg
    text: "Huntica.works — сервис видеособеседований от Boson Group"
    link: https://vc.ru/tribuna/132805-huntica-works-servis-videosobesedovaniy-ot-boson-group
    name: Читать на vc.ru
  - logo: articles2.svg
    text: "Huntica.works - сервис видеособеседований от Boson Group"
    link: https://rb.ru/opinion/video-hr-trends/
    name: Читать на rusbase
  - logo: articles-hussle.svg
    text: "Как автоматизировать процесс собеседования:
      обзор сервиса виртуальных собеседований Huntica"
    link: https://hussle.ru/kak-optimizirovat-proczess-najma-obzor-servisa-virtualnyh-sobesedovanij-huntica/
    name: Читать на hussle.ru
  - logo: articles1.svg
    text: "«О чем говорят соискатели» — сервис виртуальных собеседований Huntica
    привлек известного актера для проведения интервью"
    link: https://vc.ru/tribuna/162341-o-chem-govoryat-soiskateli-servis-virtualnyh-sobesedovaniy-huntica-privlek-izvestnogo-aktera-dlya-provedeniya-intervyu
    name: Читать на vc.ru
</i18n>
